import axios from "axios";

export const state = {
    passbookfees: [],
};

export const getters = {
    passbookfees: state => state.passbookfees,
};

export const mutations = {
    setPassbookFees(state, newValue) {
        state.passbookfees = newValue
    },
};

export const actions = {
    async fetchPassbookFees({ commit }) {
        await axios.get('/passbookfees').then(res => {
            commit('setPassbookFees', res.data.passbookfees)
        })
    },
    async filterPassbookFees({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterpassbookfees";
        await axios.post(url, formData).then((response) => {
            commit('setPassbookFees', response.data.passbookfees)
        })
    },
};
